// @flow
import BluebirdPromise from 'bluebird';

import * as r from './resources';
import { del, get, post, put } from './http';

import type { SerializedProductNote } from 'modules/product-note';
import type { Dispatch, GetState } from '~/store';

export const productNotes = (
  productNumber: string,
  catalogKey: string,
  customerNumber: string,
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  get(
    r.productNotes,
    `product_number=${productNumber}&catalog_key=${catalogKey}&customer_number=${customerNumber}`,
  );

export const createProductNote = (params: {
  note: SerializedProductNote,
}): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  post(r.productNote, '', params);

export const updateProductNote = (
  { id }: { id: string },
  updates: { note: SerializedProductNote },
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  put(r.productNote, id, updates);

export const deleteProductNote = (
  id: string,
): ((dispatch: Dispatch, getState: GetState) => BluebirdPromise<mixed>) =>
  del(r.productNote, id);
